import styled from '@emotion/styled';
import {ExNyRoute, PrRoute, ExRoute, AcRoute, MiRoute, CoRoute} from '../utils/allRouteId'


export {default as ProfileCard} from './ProfileCard';
export {default as SideBarLinks} from './SideBarLinks';
export {default as TopDisplay} from './TopDisplay';
export {default as Events} from './Events';
export {default as Loading} from './Loading';
export {default as DateFilter} from './DateFilter'
export {FilterDropDown} from './FilterDropDown';
export {SearchForm } from './SearchForm';
export {Button} from './Button';
export {UploadButton} from './UploadButton';
export {default as CustomModal} from './CustomModal';
export {default as Editor} from './Editor';




export const FilterWrapper = styled.div`
    display:flex;
    margin-top:20px;
    gap:10px;
`;

export const option1:any= (BASE_URL:string) => [
    {val:ExNyRoute, name:"Examination / NYSC",path:`${BASE_URL}`},
    {val:PrRoute, name:"Practitioner",path:`${BASE_URL}/practitional`},
    {val:ExRoute, name:"Executive",path:`${BASE_URL}/executive`},
    {val:AcRoute, name:"Academic",path:`${BASE_URL}/academic`},
    {val:MiRoute, name:"Military",path:`${BASE_URL}/military`},
    {val:CoRoute, name:"Corporate",path:`${BASE_URL}/corporate`}
]

export const option1b:any= (BASE_URL:string) => [
    {val:0, name:"All",path:`${BASE_URL}`},
    {val:ExNyRoute, name:"Examination / NYSC",path:`${BASE_URL}/examination`},
    {val:PrRoute, name:"Practitioner",path:`${BASE_URL}/practitional`},
    {val:ExRoute, name:"Executive",path:`${BASE_URL}/executive`},
    {val:AcRoute, name:"Academic",path:`${BASE_URL}/academic`},
    {val:MiRoute, name:"Military",path:`${BASE_URL}/military`},
    {val:CoRoute, name:"Corporate",path:`${BASE_URL}/corporate`}
]


export const option2:any = () =>[
    {val:1,name:"Applicants"},
    {val:2,name:"Members"},
]